import React from "react";

const ProfileProfessionalInfo = () => {
  return (
    <div className="noScroll h-90 verticalScroll pb-17 small-text">
      Coming soon
    </div>
  );
};

export default ProfileProfessionalInfo;
